<h2 class="title">Notifications</h2>

<div
  *ngIf="error$ | async as error"
  class="alert alert-danger"
  role="alert"
>{{ error | json }}</div>

<ng-container *ngIf="(loading$ | async) !== false || (notifications$ |
  async)?.length !==0; else empty">
  <div
    #scrollRef
    *ngIf="{
    loading: loading$ | async,
    pageNumber: pageNumber$ | async,
    isLast: isLast$ | async
    } as context"
    infiniteScroll
    class="notifications-list"
    (scroll)="onScroll(context.pageNumber)"
    [infiniteScrollDisabled]="context.loading || context.isLast"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [scrollWindow]="false"
  >
    <mojo-notification-item
      *ngFor="let notification of notifications$ | async"
      [notification]="notification"
      data-cy="notifications-list-item"
    >
    </mojo-notification-item>

    <mojo-notifications-loader *ngIf="context.loading === true">
    </mojo-notifications-loader>
    <span
      class="last-page-message"
      *ngIf="context.isLast"
    >That's all we have
      got for you</span>
  </div>
</ng-container>

<ng-template #empty>
  <div
    class="empty-list"
    data-cy="notifications-empty-list"
  >You don't have any notifications yet.</div>
</ng-template>
